var _themes;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import styled, { css, ThemeProvider } from 'styled-components';
import { linearGradient, mix, transparentize } from 'polished';
import tscStyles from '../constants/TscStyles';
import TscThemeName from '../constants/TscThemeName';
import linkClickHandler from '../utils/link-click-handler';
import { getClassName } from '../utils/get-class-name';
import TscButtonContentType from '../constants/TscButtonContentType';
import TscButtonSize from '../constants/TscButtonSize';
import TscButtonType from '../constants/TscButtonType';
import TscButtonGlyphPlacement from '../constants/TscButtonGlyphPlacement';
var ninetyPercentColorModifier = 0.9;
var eightyFivePercentColorModifier = 0.85;
var eightyPercentColorModifier = 0.8;
var screencastGradient = linearGradient({
  colorStops: [tscStyles.color.action.screencastPrimaryStop1, tscStyles.color.action.screencastPrimaryStop2],
  toDirection: '90deg',
  fallback: tscStyles.color.brand.screencast
});
var screencastGradientHover = linearGradient({
  colorStops: [tscStyles.color.action.screencastPrimaryStop1Hover, tscStyles.color.action.screencastPrimaryStop2Hover],
  toDirection: '90deg',
  fallback: tscStyles.color.brand.screencast
});
var themes = (_themes = {}, _defineProperty(_themes, TscThemeName.dawn, {
  cta: {
    background: tscStyles.color.action.cta,
    color: tscStyles.color.text.light,
    hoverColor: mix(ninetyPercentColorModifier, tscStyles.color.action.cta, tscStyles.color.modifier.dark),
    activeColor: mix(eightyFivePercentColorModifier, tscStyles.color.action.cta, tscStyles.color.modifier.dark),
    shadowColor: tscStyles.color.global.boxShadow
  },
  primary: {
    background: tscStyles.color.action.primary,
    color: tscStyles.color.text.light,
    hoverColor: mix(ninetyPercentColorModifier, tscStyles.color.action.primary, tscStyles.color.modifier.dark),
    activeColor: mix(eightyFivePercentColorModifier, tscStyles.color.action.primary, tscStyles.color.modifier.dark),
    shadowColor: tscStyles.color.global.boxShadow
  },
  primaryCamtasia: {
    background: tscStyles.color.action.camtasiaPrimary,
    color: tscStyles.color.text.light,
    hoverColor: mix(ninetyPercentColorModifier, tscStyles.color.action.camtasiaPrimary, tscStyles.color.modifier.dark),
    activeColor: mix(eightyFivePercentColorModifier, tscStyles.color.action.camtasiaPrimary, tscStyles.color.modifier.dark),
    shadowColor: tscStyles.color.global.boxShadow
  },
  primaryScreencast: {
    background: screencastGradient.backgroundImage.toString(),
    color: tscStyles.color.text.dark,
    hoverColor: screencastGradientHover.backgroundImage.toString(),
    activeColor: screencastGradientHover.backgroundImage.toString(),
    shadowColor: tscStyles.color.global.boxShadow
  },
  secondary: {
    background: tscStyles.color.action.secondaryDawn,
    color: tscStyles.color.text.mediumDark,
    hoverColor: mix(ninetyPercentColorModifier, tscStyles.color.action.secondaryDawn, tscStyles.color.modifier.dark),
    activeColor: mix(eightyFivePercentColorModifier, tscStyles.color.action.secondaryDawn, tscStyles.color.modifier.dark),
    shadowColor: tscStyles.color.global.boxShadow
  },
  tertiary: {
    background: tscStyles.color.global.transparent,
    color: tscStyles.color.text.mediumDark,
    hoverColor: transparentize(ninetyPercentColorModifier, tscStyles.color.modifier.dark),
    activeColor: transparentize(eightyFivePercentColorModifier, tscStyles.color.modifier.dark),
    shadowColor: tscStyles.color.global.boxShadow
  },
  destructive: {
    background: tscStyles.color.action.destructive,
    color: tscStyles.color.text.light,
    hoverColor: mix(ninetyPercentColorModifier, tscStyles.color.action.destructive, tscStyles.color.modifier.light),
    activeColor: mix(eightyFivePercentColorModifier, tscStyles.color.action.destructive, tscStyles.color.modifier.light),
    shadowColor: tscStyles.color.global.boxShadow
  },
  floating: {
    background: tscStyles.color.global.transparent,
    color: tscStyles.color.text.mediumDark,
    hoverColor: mix(ninetyPercentColorModifier, tscStyles.color.action.primary, tscStyles.color.text.light),
    activeColor: mix(eightyFivePercentColorModifier, tscStyles.color.action.primary, tscStyles.color.text.mediumDark),
    shadowColor: tscStyles.color.global.boxShadow
  }
}), _defineProperty(_themes, TscThemeName.dusk, {
  cta: {
    background: tscStyles.color.action.cta,
    color: tscStyles.color.text.light,
    hoverColor: mix(ninetyPercentColorModifier, tscStyles.color.action.cta, tscStyles.color.modifier.dark),
    activeColor: mix(eightyFivePercentColorModifier, tscStyles.color.action.cta, tscStyles.color.modifier.dark),
    shadowColor: tscStyles.color.global.boxShadow
  },
  primary: {
    background: tscStyles.color.action.primary,
    color: tscStyles.color.text.light,
    hoverColor: mix(ninetyPercentColorModifier, tscStyles.color.action.primary, tscStyles.color.modifier.dark),
    activeColor: mix(eightyFivePercentColorModifier, tscStyles.color.action.primary, tscStyles.color.modifier.dark),
    shadowColor: tscStyles.color.global.boxShadow
  },
  primaryCamtasia: {
    background: tscStyles.color.action.camtasiaPrimary,
    color: tscStyles.color.text.light,
    hoverColor: mix(ninetyPercentColorModifier, tscStyles.color.action.camtasiaPrimary, tscStyles.color.modifier.dark),
    activeColor: mix(eightyFivePercentColorModifier, tscStyles.color.action.camtasiaPrimary, tscStyles.color.modifier.dark),
    shadowColor: tscStyles.color.global.boxShadow
  },
  primaryScreencast: {
    background: screencastGradient.toString(),
    color: tscStyles.color.text.dark,
    hoverColor: mix(ninetyPercentColorModifier, tscStyles.color.brand.screencast, tscStyles.color.modifier.dark),
    activeColor: mix(eightyFivePercentColorModifier, tscStyles.color.brand.screencast, tscStyles.color.modifier.dark),
    shadowColor: tscStyles.color.global.boxShadow
  },
  secondary: {
    background: tscStyles.color.action.secondaryDusk,
    color: tscStyles.color.text.light,
    hoverColor: mix(ninetyPercentColorModifier, tscStyles.color.action.secondaryDusk, tscStyles.color.modifier.light),
    activeColor: mix(eightyFivePercentColorModifier, tscStyles.color.action.secondaryDusk, tscStyles.color.modifier.light),
    shadowColor: tscStyles.color.global.boxShadow
  },
  tertiary: {
    background: tscStyles.color.global.transparent,
    color: tscStyles.color.text.light,
    hoverColor: transparentize(eightyPercentColorModifier, tscStyles.color.modifier.light),
    activeColor: transparentize(eightyFivePercentColorModifier, tscStyles.color.modifier.light),
    shadowColor: tscStyles.color.global.boxShadow
  },
  destructive: {
    background: tscStyles.color.action.destructive,
    color: tscStyles.color.text.light,
    hoverColor: mix(ninetyPercentColorModifier, tscStyles.color.action.destructive, tscStyles.color.modifier.light),
    activeColor: mix(eightyFivePercentColorModifier, tscStyles.color.action.destructive, tscStyles.color.modifier.light),
    shadowColor: tscStyles.color.global.boxShadow
  },
  floating: {
    background: tscStyles.color.global.transparent,
    color: tscStyles.color.text.light,
    hoverColor: mix(ninetyPercentColorModifier, tscStyles.color.action.primary, tscStyles.color.modifier.dark),
    activeColor: mix(eightyFivePercentColorModifier, tscStyles.color.action.primary, tscStyles.color.modifier.dark),
    shadowColor: tscStyles.color.global.boxShadow
  }
}), _themes);
var buttonPadding = css(["padding:", ";"], function (props) {
  if (props.contentType === TscButtonContentType.glyph) {
    return '0';
  }

  return '0 .75rem';
});
var StyledButton = styled.button.attrs(function (props) {
  return props.testId ? {
    'data-test-id': props.testId
  } : {};
}).withConfig({
  displayName: "ControlButton__StyledButton"
})(["flex:", ";", " -webkit-border-fit:border !important;-webkit-appearance:none;display:inline-block;overflow:hidden;visibility:", ";line-height:2rem;width:", ";height:", ";cursor:pointer;background-color:transparent;box-sizing:border-box;position:relative;border:0;border-radius:", ";font-family:'Proxima Nova','proxima-nova',sans-serif;font-size:0.875rem;font-weight:600;letter-spacing:0.05em;text-decoration:none;text-align:center;vertical-align:middle;outline:none;background:", ";color:", ";fill:", ";opacity:", ";pointer-events:", ";&::-moz-focus-inner{border:0;}&:focus-visible{outline:none;&:after{content:'';display:block;position:absolute;top:2px;right:2px;bottom:2px;left:2px;border:2px solid currentColor;border-radius:", ";}}", ""], function (props) {
  return props.isFullWidth ? '1 1 auto' : 'none';
}, buttonPadding, function (props) {
  return props.visible ? 'inherit' : 'hidden';
}, function (props) {
  return props.prioritizedWidth;
}, function (props) {
  return props.buttonSize === TscButtonSize.normal ? '2rem' : '3rem';
}, function (props) {
  return props.buttonSize === TscButtonSize.normal ? tscStyles.border.radius.medium : tscStyles.border.radius.large;
}, function (props) {
  return props.theme.background;
}, function (props) {
  return props.theme.color;
}, function (props) {
  return props.theme.color;
}, function (props) {
  return props.disabled ? '0.5' : '1';
}, function (props) {
  return props.disabled ? 'none' : 'auto';
}, function (props) {
  return props.buttonSize === TscButtonSize.normal ? '4.5px' : '6px';
}, function (props) {
  return props.active ? "\n      box-shadow: inset 0 2px 3px ".concat(props.buttonType === TscButtonType.floating ? 'none' : props.theme.shadowColor, ";\n      background: ").concat(props.buttonType === TscButtonType.floating ? props.theme.background : props.theme.activeColor, ";\n      fill: ").concat(props.buttonType === TscButtonType.floating ? props.theme.activeColor : props.theme.color, ";\n   ") : "\n      &:hover {\n         background: ".concat(props.buttonType === TscButtonType.floating ? props.theme.background : props.theme.hoverColor, ";\n         box-shadow: 0 2px 3px ").concat(props.buttonType === TscButtonType.floating ? 'none' : props.theme.shadowColor, ";\n         fill: ").concat(props.buttonType === TscButtonType.floating ? props.theme.hoverColor : props.theme.color, ";\n         text-decoration: none;\n      }\n\n      &:active {\n         box-shadow: inset 0 2px 3px ").concat(props.buttonType === TscButtonType.floating ? 'none' : props.theme.shadowColor, ";\n         background: ").concat(props.buttonType === TscButtonType.floating ? props.theme.background : props.theme.activeColor, ";\n         fill: ").concat(props.buttonType === TscButtonType.floating ? props.theme.activeColor : props.theme.color, ";\n      }");
});
var StyledButtonAnchor = StyledButton.withComponent('a');
var ButtonLabel = styled.span.withConfig({
  displayName: "ControlButton__ButtonLabel"
})(["pointer-events:none;vertical-align:middle;display:inline-block;line-height:inherit;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;max-width:100%;"]);
var ButtonLabelNextToGlyph = styled(ButtonLabel).withConfig({
  displayName: "ControlButton__ButtonLabelNextToGlyph"
})([":nth-child(2){margin-left:0.5rem;}"]);
var GlyphStyled = styled.span.withConfig({
  displayName: "ControlButton__GlyphStyled"
})(["pointer-events:none;display:inline-block;vertical-align:middle;svg{display:block;}img{display:block;}:nth-child(2){margin-left:0.5rem;}"]);

var getContentType = function getContentType(label, glyph) {
  if (label && glyph) {
    return TscButtonContentType.mixed;
  }

  if (!label && glyph) {
    return TscButtonContentType.glyph;
  }

  return TscButtonContentType.text;
};

var defaultProps = {
  active: false,
  ariaExpanded: false,
  ariaPressed: false,
  buttonSize: TscButtonSize.normal,
  buttonType: TscButtonType.primary,
  disabled: false,
  glyphPlacement: TscButtonGlyphPlacement.left,
  isFullWidth: false,
  label: '',
  openLinkInNewTab: false,
  themeName: TscThemeName.dawn,
  visible: true
}; // because backing button can be HTMLButtonElement or HTMLAnchorElement, this cannot be more specific, it
// using base-class HTMLElement (RefObject<HTMLElement>| ((ref: HTMLElement) => void) | null | undefined) did not satisfy

var ControlButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
      active = _defaultProps$props.active,
      ariaExpanded = _defaultProps$props.ariaExpanded,
      ariaLabel = _defaultProps$props.ariaLabel,
      ariaPressed = _defaultProps$props.ariaPressed,
      buttonSize = _defaultProps$props.buttonSize,
      buttonType = _defaultProps$props.buttonType,
      className = _defaultProps$props.className,
      disabled = _defaultProps$props.disabled,
      glyph = _defaultProps$props.glyph,
      glyphPlacement = _defaultProps$props.glyphPlacement,
      href = _defaultProps$props.href,
      isFullWidth = _defaultProps$props.isFullWidth,
      label = _defaultProps$props.label,
      onBlur = _defaultProps$props.onBlur,
      _onClick = _defaultProps$props.onClick,
      openLinkInNewTab = _defaultProps$props.openLinkInNewTab,
      testId = _defaultProps$props.testId,
      themeName = _defaultProps$props.themeName,
      title = _defaultProps$props.title,
      type = _defaultProps$props.type,
      visible = _defaultProps$props.visible,
      width = _defaultProps$props.width; // overlay the defaultProps and passed in props in logical order and spread to constant values
  // TODO: not sure why we enforce this tbh, i suspect it has to do with accessibility, but we have aria-label, so if that is set, it should also pass?
  // PWC passes in empty-string here for comment-markers, which is why we specify typeof check, label is 'default' to '' so it will always be string


  if (!label && typeof title !== 'string') {
    throw new Error('The prop `title` is required when the prop `label` is not specified.');
  }

  var contentType = getContentType(label, glyph);

  var glyphStyledElement = glyph && _jsx(GlyphStyled, {
    className: getClassName(className, 'glyph-styled'),
    children: glyph
  });

  var buttonLabel = null;

  if (label) {
    if (glyph) {
      buttonLabel = _jsx(ButtonLabelNextToGlyph, {
        className: getClassName(className, 'button-label-next-to-glyph'),
        children: label
      });
    } else {
      buttonLabel = _jsx(ButtonLabel, {
        className: getClassName(className, 'button-label'),
        children: label
      });
    }
  }

  var isAnchor = !!href;
  var leftElement = glyphPlacement === TscButtonGlyphPlacement.left ? glyphStyledElement : buttonLabel;
  var rightElement = glyphPlacement === TscButtonGlyphPlacement.left ? buttonLabel : glyphStyledElement;
  var controlProps = {
    active: active,
    buttonSize: buttonSize,
    buttonType: buttonType,
    contentType: contentType,
    disabled: disabled,
    onBlur: onBlur,
    // 'prioritized because isFullWidth || explicit width || contentType.glyph || auto (nested because this replaces a 10-line func)
    prioritizedWidth: isFullWidth ? '100%' : width || (contentType === TscButtonContentType.glyph ? '2rem' : 'auto'),
    isFullWidth: isFullWidth,
    testId: testId,
    title: title,
    visible: visible,
    ref: ref
  };
  return _jsx(ThemeProvider, {
    theme: themes[themeName][buttonType !== null && buttonType !== void 0 ? buttonType : TscButtonType.primary],
    children: isAnchor ? _jsxs(StyledButtonAnchor, _objectSpread(_objectSpread(_objectSpread({
      className: getClassName(className, null, 'styled-button-anchor')
    }, controlProps), {}, {
      href: href,
      onClick: function onClick(e) {
        return linkClickHandler(e, _onClick, openLinkInNewTab);
      }
    }, openLinkInNewTab && {
      target: '_blank',
      rel: 'noopener noreferrer'
    }), {}, {
      children: [leftElement, rightElement]
    })) : _jsxs(StyledButton, _objectSpread(_objectSpread({
      className: getClassName(className, null, 'styled-button')
    }, controlProps), {}, {
      onClick: _onClick,
      type: type,
      "aria-expanded": ariaExpanded,
      "aria-pressed": ariaPressed,
      "aria-label": ariaLabel,
      children: [leftElement, rightElement]
    }))
  });
});
ControlButton.displayName = 'ControlButton';
ControlButton.defaultProps = defaultProps;
export { ControlButton, StyledButton, StyledButtonAnchor };
export default ControlButton;